import React from 'react';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type Props = {
  currentStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext?: () => void;
  isNextDisabled?: boolean;
};

export default function FillingStepNav({
  currentStep,
  totalSteps,
  onPrev,
  onNext,
  isNextDisabled = false,
}: Props) {
  return (
    <div className="flex flex-row items-center gap-2">
      <span>
        {['Step', currentStep, 'of', totalSteps].join(' ')}
      </span>
      <div>
        <IconButton
          disabled={currentStep === 1}
          onClick={onPrev}
          className="!p-0"
        >
          <ChevronLeftIcon />
        </IconButton>
        <IconButton
          disabled={isNextDisabled}
          onClick={onNext}
          className="!p-0"
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
    </div>
  );
}
